module.exports = __webpack_public_path__ + "static/img/最具潜力新能源车.a5d2864f.png";